module.exports = __webpack_public_path__ + "img/alshrouq.c90fa6c9.png";